module.exports = __webpack_public_path__ + "img/Python.9ae7d0c2.png";